import {choice} from 'constants/url';
import useAdd from '../../../components/hooks/useAdd';
import {AddingOptions} from '../../../components/grid-dx/types';

function useAddChoice() {
  const addCourse = useAdd(choice);
  return (addingOptions: AddingOptions) => addCourse(addingOptions);
}

export default useAddChoice;
